import React, {memo, useEffect, useState} from 'react';
import {injectIntl, useIntl} from 'react-intl';
import {useNavigate, useParams} from "react-router-dom";
import {downloadReportFile, resetDownloadReportFile} from "Modules/reports/views/main/components/reportsTab/redux/slice";
import {useDispatch, useSelector} from "react-redux";
import Loading from "../../../components/Loading";

const DownloadReportView = () => {
    const {id} = useParams();
    const {messages} = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const {
        loadingDownloadReportFile,
        urlReportFile,
        error
    } = useSelector(state => state.reportsTapSearchReportLogRedux);
    const [downloadStatus, setDownloadStatus] = useState('pending');

    useEffect(() => {
        if (id) {
            dispatch(downloadReportFile({id: id}))
        }
    }, [id])

    useEffect(() => {
        if (urlReportFile && downloadStatus === 'pending') {
            setDownloadStatus('downloading');
            downloadFile(urlReportFile);
        }
    }, [urlReportFile])

    useEffect(() => {
        if (error) {
            if (error === 'Expirate Code')
                navigate('/error/page_expirate_link')
            else
                navigate('/error')
        }
    }, [error]);

    const downloadFile = (url) => {
        const a = document.createElement('a');
        a.href = url;
        a.download = "";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);


        setDownloadStatus('completed');
        dispatch(resetDownloadReportFile());

        setTimeout(() => {
            closeWindow();
        }, 1500);
    }

    const closeWindow = () => {
        try {
            window.close();
        } finally {
            // In some browsers, window.close() may be blocked if the window was not opened via script
            // So we set the status to need manual close
            setTimeout(() => {
                setDownloadStatus('need_manual_close');
            }, 500);
        }
    }

    return (
        <div style={{width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {loadingDownloadReportFile && <Loading full/>}

            {downloadStatus === 'completed' && (
                <div style={{textAlign: 'center', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Loading />
                    <p>{messages['downloadReport_downloading']}</p>
                </div>
            )}

            {downloadStatus === 'need_manual_close' && (
                <div style={{textAlign: 'center', padding: '20px'}}>
                    <h3>{messages['downloadReport_manualClose_title']}</h3>
                    <p>{messages['downloadReport_manualClose_message']}</p>
                </div>
            )}

            {downloadStatus === 'error' && (
                <div style={{textAlign: 'center', padding: '20px'}}>
                    <p>{messages['downloadReport_error_message']}</p>
                </div>
            )}
        </div>
    );
};

export default injectIntl(memo(DownloadReportView));
